import { subscribeBroadcast } from '@highlight/ipc'
import { PERFORMANCE_MONITOR_TOPIC, type PerformanceSnapshot } from '@shared/performance-monitor'
import { useEffect, useState } from 'react'
import { METRIC_HISTORY_LENGTH, type PerformanceHistorySample } from '@renderer/features/performance-monitor/model'

interface PerformanceSnapshots {
  snapshot: PerformanceSnapshot | null
  history: Array<PerformanceHistorySample>
}

export function usePerformanceSnapshots(enabled: boolean): PerformanceSnapshots {
  const [snapshot, setSnapshot] = useState<PerformanceSnapshot | null>(null)
  const [history, setHistory] = useState<Array<PerformanceHistorySample>>([])

  useEffect(() => {
    if (!enabled) {
      setSnapshot(null)
      setHistory([])
      return
    }

    return subscribeBroadcast<PerformanceSnapshot>(PERFORMANCE_MONITOR_TOPIC, (next) => {
      const slowestAxWalkMs =
        next.axPolls && next.axPolls.length > 0 ? Math.max(...next.axPolls.map(({ lastMs }) => lastMs)) : undefined
      setSnapshot(next)
      setHistory((previous) =>
        [
          ...previous,
          {
            totals: next.totals,
            ipcFramesPerSecond: next.ipcFanout?.framesPerSecond,
            slowestAxWalkMs,
          },
        ].slice(-METRIC_HISTORY_LENGTH),
      )
    })
  }, [enabled])

  return { snapshot, history }
}
